// Shared navigation data for Header and Footer components

// Dynamic product links - loaded from API (currently disabled)
// import { productService } from '../services/productService';
// let cachedProductLinks = [];
// let lastFetchTime = 0;
// const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes cache

export const getProductLinks = () => {
  // For now, just return the 5 main static products
  // You can enable API integration later if needed
  return getFallbackProductLinks();
  
  /* API integration disabled for now - uncomment when needed
  const now = Date.now();
  
  // Return cached data if it's still fresh
  if (cachedProductLinks.length > 0 && (now - lastFetchTime) < CACHE_DURATION) {
    return cachedProductLinks;
  }
  
  try {
    const result = await productService.getAllProducts();
    
    if (result.success && result.data) {
      // Format API products for navigation
      const apiProducts = result.data.map((product, index) => ({
        id: product.id || `api-${index + 1}`,
        title: product.attributes?.title || product.title || `Product ${index + 1}`,
        href: `/product-details/${product.id || index + 1}`,
        description: product.attributes?.description || product.description || `Learn more about ${product.attributes?.title || product.title}`
      }));
      
      // Merge with static products, API products first
      cachedProductLinks = [...apiProducts, ...getFallbackProductLinks()];
      
      lastFetchTime = now;
      return cachedProductLinks;
    } else {
      // Return static products if API fails
      return getFallbackProductLinks();
    }
  } catch (error) {
    console.error('Error fetching product links:', error);
    // Return static products if API fails
    return getFallbackProductLinks();
  }
  */
};

// Fallback product links (used when API is unavailable)
const getFallbackProductLinks = () => [
  { 
    id: 'queuepro', 
    title: "Queue-Pro", 
    href: "/products/queuepro", 
    subtitle: "Advanced Queue Management System",
    description: "Transform your customer service experience with Queue-Pro, the comprehensive queue management solution. Streamline operations, reduce wait times, and enhance customer satisfaction through intelligent queue routing, real-time analytics, and automated service delivery. Perfect for banks, hospitals, government offices, and retail establishments.",
    image: "/png/queue-pro.png"
  },
  { 
    id: 'ebs', 
    title: "EBS", 
    href: "/products/ebs", 
    subtitle: "Enterprise Business Solutions",
    description: "Empower your enterprise with EBS, a complete business management platform that integrates all your organizational processes. From HR management and financial reporting to supply chain optimization and customer relationship management, EBS provides the tools you need to scale your business efficiently and make data-driven decisions.",
    image: "/png/ebs.png"
  },
  { 
    id: 'insightdb', 
    title: "InsightDB", 
    href: "/products/insightdb", 
    subtitle: "Business Intelligence Database & Analytics",
    description: "Unlock the power of your data with InsightDB, an advanced business intelligence platform that transforms raw data into actionable insights. Features powerful analytics, customizable dashboards, predictive modeling, and real-time reporting capabilities to help you understand trends, optimize performance, and drive strategic growth.",
    image: "/png/insightdb.png"
  },
  { 
    id: 'ossp', 
    title: "OSSP", 
    href: "/products/ossp", 
    subtitle: "One Stop Service Platform - Streamlining e-Governance",
    description: "Revolutionize government service delivery with OSSP, a unified digital platform that brings all public services under one roof. Citizens can access multiple government services seamlessly, track application status, make payments, and communicate with departments efficiently, creating a truly digital governance experience.",
    image: "/png/ossp_logo.png"
  },
  { 
    id: 'smart-delivery-platform', 
    title: "Smart Delivery Platform (eCommerce Platform)", 
    href: "/products/smart-delivery-platform", 
    subtitle: "eCommerce Platform for Smart Delivery Solutions",
    description: "Accelerate your online business with our Smart Delivery Platform, a comprehensive eCommerce solution that combines powerful storefront capabilities with intelligent logistics management. Features include inventory management, order processing, payment integration, delivery tracking, and customer analytics for complete online business success.",
    image: "/png/smart_deli_info.png"
  },
  // { 
  //   id: 'digital-corporate-banking', 
  //   title: "Digital Corporate Banking Platform", 
  //   href: "/products/digital-corporate-banking", 
  //   subtitle: "Comprehensive Banking Solutions for Modern Enterprises",
  //   description: "Transform your banking operations with our Digital Corporate Banking Platform, specially designed to enable remote access to corporate banking services. This comprehensive platform includes portal and mobile app capabilities, online transaction processing, digital forms integration, and advanced analytics to provide convenience, accessibility, and efficiency for corporate banking customers.",
  //   image: "/png/DigitalCorporate.png"
  // },
];

// Function to get service links
export const getServiceLinks = () => {
  return serviceLinks;
};

// Static product links for immediate use (will be replaced by dynamic data)
export const productLinks = getFallbackProductLinks();

export const companyLinks = [
  { title: "About Us", href: "/about-us" },
  { title: "Career", href: "/careers" },
  // { title: "Careers", href: "/careers" },
  { title: "Contact", href: "/contact" },
];

export const serviceLinks = [
  { 
    id: 'api-integration', 
    title: "API Integration Solutions", 
    href: "/services/api-integration", 
    description: "Seamless integration of systems and applications across platforms",
    image: "/svg/API_Integration.svg"
  },
  { 
    id: 'etl-data-warehouse', 
    title: "ETL & Data Warehouse Solutions", 
    href: "/services/etl-data-warehouse", 
    description: "Business intelligence and data analytics solutions for informed decisions",
    image: "/svg/ETL.svg"
  },
  { 
    id: 'managed-services', 
    title: "Managed Services", 
    href: "/services/managed-services", 
    description: "Comprehensive managed IT services for business continuity",
    image: "/svg/product_hand_setting.svg"
  },
  { 
    id: 'customized-software-development', 
    title: "Customized Software Development", 
    href: "/services/customized-software-development", 
    description: "Tailored software solutions built to meet your specific business needs",
    image: "/svg/Customized_Software_Development.svg"
  },
  { 
    id: 'customized-mobile-app-development', 
    title: "Customized Mobile App Development", 
    href: "/services/customized-mobile-app-development", 
    description: "Native and cross-platform mobile application development",
    image: "/svg/Mobile_App_Development.svg"
  },
  { 
    id: 'record-digitization-services', 
    title: "Record Digitization Services", 
    href: "/services/record-digitization-services", 
    description: "Digital transformation of physical records and documents",
    image: "/png/digital-transformation.png"
  },
  { 
    id: 'tech-support-services', 
    title: "Tech Support Services", 
    href: "/services/tech-support-services", 
    description: "24/7 technical support and maintenance services",
    image: "/svg/product_group.svg"
  },
  { 
    id: 'devops-services', 
    title: "DevOps Services", 
    href: "/services/devops-services", 
    description: "Streamlined development and operations with CI/CD pipelines",
    image: "/png/cloud-migration.png"
  },
  { 
    id: 'application-migration-services', 
    title: "Application Migration Services", 
    href: "/services/application-migration-services", 
    description: "Secure migration of applications to modern platforms",
    image: "/png/cloud-migration.png"
  },
  { 
    id: 'ai-driven-cybersecurity-services', 
    title: "AI-Driven Cybersecurity", 
    href: "/services/ai-driven-cybersecurity-services", 
    description: "Advanced AI-powered cybersecurity solutions",
    image: "/png/ai-driven-cybercesurity.png"
  }
];

export const resourceLinks = [
  { title: "Case Studies", href: "/case-studies" },
  { title: "Newsroom", href: "/newsroom" },
  { title: "Partnerships & Collaborations", href: "/partnerships-collaborations" },
  { title: "Support portal", href: "https://support.ba-systems.com/" },
];

export const footerBottomLinks = [
  { title: "Privacy Policy", href: "/privacy-policy" },
//   { title: "Terms of Service", href: "/terms" },
//   { title: "Accessibility", href: "/accessibility" },
];
